import { PortableText } from '@portabletext/react'
import { Tag } from 'components/Global/Tag'

export const PrinciplesGrid = ({ title, items }) => {
  return (
    <div className="gap-20 p-20">
      <div className="rounded-10 bg-whiter p-20 shadow-md">
        <h3 className="text-medium text-16 leading-120 text-darkGray md:text-20">
          {title}
        </h3>
        <div className="grid grid-cols-1 gap-14 pt-[36px] md:grid-cols-2">
          {items.map((item) => {
            return (
              <div
                key={item._key}
                className="flex flex-col rounded-10 bg-[#F5F5F7] p-10"
              >
                <Tag className="self-start bg-yellow">{item.tag}</Tag>
                <div className="pt-10 text-12 leading-120 text-darkGray">
                  {item.title}
                </div>
                <div className="pt-4 text-12 leading-120 text-gray">
                  <PortableText value={item.text} />
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
